import React from 'react';
import { SEOTableRow, TableConfig } from 'src/api/models/SEOTable';
import { RowContainer } from './Row.styles';
import Cell, { getCellTemplateColumns } from './Cell';

interface RowProps extends SEOTableRow, TableConfig {
  index: number;
}

const Row = ({ columns, title, index, ...rest }: RowProps): JSX.Element => {
  const { firstColumnCustomWidth, columnCount } = rest;
  const templateColumns = getCellTemplateColumns(firstColumnCustomWidth, columnCount);

  return (
    <RowContainer
      templateColumns={templateColumns}
      columnCount={columnCount}
    >
      <Cell
        {...rest}
        text={title}
        rowIndex={index}
        isTitle
        className='title-cell'
      />
      {columns.map((column, columnIndex) => (
        <Cell
          key={`${index}-${columnIndex}`}
          entries={column}
          rowIndex={index}
          {...rest}
        />
      ))}
    </RowContainer>
  );
};

export default Row;
